const CaretDown = ({fill, width = 4}: {fill: string; width?: number}) => (
  <svg width={width} height={width} viewBox="0 0 4 4" fill="none" xmlns="http://www.w3.org/2000/svg" aria-label="">
    <path
      d="M0.0404306 0.959082L1.86284 3.28355C1.91638 3.35037 2.09039 3.35037 2.14393 3.28355L3.95956 0.959082C4.04594 0.851291 3.98479 0.667 3.8626 0.667H0.137377C0.0152313 0.667 -0.0459377 0.851298 0.0404306 0.959082Z"
      fill={fill}
    />
  </svg>
)

export default CaretDown
